import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import useUserId from './useUserId2';
import { fetchUser } from 'services/userService';

const useFetchUser = (id=null) => {
    const [loading, setLoading] = useState(true);
    const [formData, setFormData] = useState([]);
    const [error, setError] = useState(null);
    const navigate = useNavigate();
    const userId = useUserId();
    const acces = localStorage.getItem('accessToken');
    console.log('acces', acces);
    useEffect(() => {
        console.log('Current userId:', userId); // Debug userId

        const loadUser = async () => {
            if (!userId) {
                if (id) {
                    try {
                        setLoading(true);
                        if (acces){
                            console.log('its called')
                        const data = await fetchUser(id);
                        setFormData(data);}
                    } catch (error) {
                        console.error('Error fetching user by id:', error);
                        setError("Failed to fetch user data");
                    } finally {
                        setLoading(false);
                    }
                    return;
                }
                console.log('No userId available');
                return;
            }

            // console.log('Starting to load user data...'); // Debug loading start
            try {
                if (acces){
                setLoading(true);
                // Make sure we're using the correct userId format
                const userIdValue = userId.userId || userId;
                // console.log('Fetching with userId:', userIdValue); // Debug userId value
                
                const data = await fetchUser(userIdValue);
                // console.log('Received data:', data); // Debug received data
                
                setFormData(data); }
            } catch (error) {
                console.error('Detailed error:', error); 
                if (error.message === "Unauthorized") {
                    console.log("Unauthorized. Redirecting to login page....");
                    navigate("/login");
                    return;
                }
                setError("Failed to fetch user data");
            } finally {
                setLoading(false);
            }
        };
        // console.log('*')
        loadUser();
    }, [userId, id, acces]); // Fixed: removed 'navigate' from dependencies

    // Debug values being returned
    // useEffect(() => {
    //     console.log('Current hook state:', {
    //         loading,
    //         formData,
    //         error
    //     });
    // }, [loading, formData, error]);

    return { formData, loading, error };
};

export default useFetchUser;